import { useEffect } from 'react';
import { useDeviceSelectors } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import { Path } from '../../Routing/Paths';

const useIncorrectPlatformFallback = () => {
  const navigate = useNavigate();
  const [selectors] = useDeviceSelectors(window.navigator.userAgent);

  useEffect(() => {
    if (!selectors.isSafari) {
      navigate(
        {
          pathname: Path.KindredPluginActivationAlternateBrowser,
          search: location.search,
        },
        { replace: true }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectors.isSafari]);
};

export default useIncorrectPlatformFallback;
